import { useState, useEffect } from "react";
import "./ProductDetailTwo.scss";
import { FiShoppingCart } from "react-icons/fi";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useDocument } from "../../firebase-files/hooks/useDocument";
import { useCollection } from "../../firebase-files/hooks/useCollection";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import PGLoaders from "../../default-pages/PGLoaders/PGLoaders";
import useCart from "../../firebase-files/hooks/useCart";
import MuiAlert from "@mui/material/Alert";
import { Snackbar } from "@mui/material";
import EditProductDetails from "./EditProductDetails";
import ProductSettings from "./ProductSettings";
import firebase from "firebase/app";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import useWishlist from "../../firebase-files/hooks/useWishlist";
import { useLocation } from "react-router-dom";
import "firebase/storage";
import "firebase/firestore";
import DeleteProductImage from "./DeleteProductImage";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import ProductReviews from "./ProductReviews";
import Modal from "@mui/material/Modal";
import { Tabs, Tab, Box, TextField, Button } from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

const ProductDetailTwo = () => {
  const { id } = useParams();
  const { user } = useAuthContext();
  const location = useLocation();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [imageToDelete, setImageToDelete] = useState(null);

  const { document: checkoutBtnDoc } = useDocument(
    "pages-data",
    "productDetails"
  );

  const { document: TAXDocument } = useDocument("settings", "tax_GST");
  const { document: currencyDocument } = useDocument("settings", "currency");
  const { document: multiLocation } = useDocument("settings", "multiLocation");
  const [isUploading, setIsUploading] = useState(false); // State to track upload

  const navigate = useNavigate();
  const { document: pageControlDoc } = useDocument("settings", "pagesControl");

  // Fetch current product data
  const { document: productDoc, error: productError } = useDocument(
    "products",
    id
  );
  const { document: appTypeDoc } = useDocument("settings", "AppType");
  const { wishlistItems, addToWishlist, removeFromWishlist } = useWishlist();

  const { document: productDetailsVisibility } = useDocument(
    "settings",
    "productDetailsVisibility"
  );

  // Fetch all products for similar/likeable products
  const { documents: allProducts, error: productsError } =
    useCollection("products");
  const { documents: vendors } = useCollection("vendors");

  // Fetch currency settings
  const { document: currencyDoc, error: currencyError } = useDocument(
    "settings",
    "currency"
  );

  const { updateDocument } = useFirestore("products");

  // const phone = user?.phoneNumber?.replace("+91", "91");
  // const userInfo = users?.find((u) => u.id === phone);
  const isAdmin = user && user.role === "admin";
  const isSuperAdmin = user && user.role === "superAdmin";

  // Local state
  const [activeTab, setActiveTab] = useState("description");
  const [quantity, setQuantity] = useState(1);
  const [pincode, setPincode] = useState("");
  const [activeImage, setActiveImage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [similarProducts, setSimilarProducts] = useState([]);
  const [likeableProducts, setLikeableProducts] = useState([]);
  const [selectedSize, setSelectedSize] = useState("");
  const [size, setSize] = useState("");
  const [isSizeModalOpen, setIsSizeModalOpen] = useState(false);
  const [sizeUrl, setSizeUrl] = useState(""); // New state for size URL
  const [selectedColor, setSelectedColor] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false); // State for snackbar
  const [snackbarMessage, setSnackbarMessage] = useState(""); // State for snackbar message
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editField, setEditField] = useState(null);
  // STATES FOR SUBSCRIPTION
  const [productSubscription, setProductSubscription] = useState(false);
  const [selectedFrequencyType, setSelectedFrequencyType] = useState(""); // 'week' or 'month'
  const [selectedDeliveryInterval, setSelectedDeliveryInterval] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);

  const [isVariantModalOpen, setIsVariantModalOpen] = useState(false);
  const [variantInfo, setVariantInfo] = useState({
    variantName: "",
    variantPrice: "",
    variantUrl: "",
  });
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedVariantPrice, setSelectedVariantPrice] = useState(null);
  const [discountedPrice, setDiscountedPrice] = useState(null);
  // Update the cart related hooks and state
  const { addToCart, cartItems, removeFromCart, addToCartFromDetails } =
    useCart();
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [error, setError] = useState(null);
  const [cartQuantity, setCartQuantity] = useState(0);

  const [isSizeVisible, setIsSizeVisible] = useState(false);

  // SIZE GUIDE CODE START
  const [isSizeGuideOpen, setIsSizeGuideOpen] = useState(false);
  const [sizeGuideTab, setSizeGuideTab] = useState("inch");
  const sizeGuideInchData = [
    {
      general: "XS",
      size: "32",
      chest: "32",
      waist: "26",
      hip: "35",
      shoulder: "13.5",
      length: "54",
    },
    {
      general: "S",
      size: "34",
      chest: "34",
      waist: "28",
      hip: "37",
      shoulder: "14",
      length: "54",
    },
    {
      general: "M",
      size: "36",
      chest: "36",
      waist: "30",
      hip: "39",
      shoulder: "14.5",
      length: "54",
    },
    {
      general: "L",
      size: "38",
      chest: "38",
      waist: "32",
      hip: "41",
      shoulder: "15",
      length: "54",
    },
    {
      general: "XL",
      size: "40",
      chest: "40",
      waist: "34",
      hip: "43",
      shoulder: "15.5",
      length: "54",
    },
    {
      general: "XXL",
      size: "42",
      chest: "42",
      waist: "36",
      hip: "45",
      shoulder: "16",
      length: "54",
    },
  ];
  const sizeGuideCmData = [
    {
      general: "XS",
      size: "81",
      chest: "81",
      waist: "66",
      hip: "89",
      shoulder: "34",
      length: "137",
    },
    {
      general: "S",
      size: "86",
      chest: "86",
      waist: "71",
      hip: "94",
      shoulder: "36",
      length: "137",
    },
    {
      general: "M",
      size: "91",
      chest: "91",
      waist: "76",
      hip: "99",
      shoulder: "37",
      length: "137",
    },
    {
      general: "L",
      size: "97",
      chest: "97",
      waist: "81",
      hip: "104",
      shoulder: "38",
      length: "137",
    },
    {
      general: "XL",
      size: "102",
      chest: "102",
      waist: "86",
      hip: "109",
      shoulder: "39",
      length: "137",
    },
    {
      general: "XXL",
      size: "107",
      chest: "107",
      waist: "91",
      hip: "114",
      shoulder: "41",
      length: "137",
    },
  ];

  // open modal for a field
  const handleOpenEditModal = (field) => {
    setEditField(field);
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setEditField(null);
  };
  // Update the useEffect for cart tracking
  useEffect(() => {
    if (cartItems && id) {
      // Find the item in cart
      const itemInCart = cartItems.find((item) => item.productId === id);
      const currentCartQuantity = itemInCart ? itemInCart.quantity : 0;
      setCartQuantity(currentCartQuantity);

      // Only update quantity if item is in cart
      if (currentCartQuantity > 0) {
        setQuantity(currentCartQuantity);
      }
    }
  }, [cartItems, id]);

  // Add this useEffect to handle URL changes
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const variantId = searchParams.get("variant");
    if (variantId) {
      const selected = document.variants.find((v) => v.id === variantId);
      if (selected) setSelectedVariant(selected);
    }
  }, [document?.variants]);

  useEffect(() => {
    if (selectedVariant?.id) {
      navigate(`?variant=${selectedVariant.id}`, { replace: true });
    }
  }, [selectedVariant]);

  useEffect(() => {
    if (selectedVariant) {
      setSelectedVariantPrice(selectedVariant.variantPrice);
      setDiscountedPrice(
        Math.ceil(
          selectedVariant.variantPrice -
            selectedVariant.variantPrice *
              (document.discount.split("%")[0] / 100)
        )
      );
    }
  }, [selectedVariant]);
  // Effect to handle loading state and data preparation
  useEffect(() => {
    if (productDoc && allProducts && currencyDoc) {
      // Prepare similar products (same category)
      const similar = allProducts
        .filter(
          (product) =>
            product.id !== id && // Exclude current product
            product.category.some((cat) => productDoc.category.includes(cat))
        )
        .slice(0, 3); // Limit to 3 products

      // Prepare likeable products (different category but similar price range)
      const productPrice = productDoc.price;
      const likeable = allProducts
        .filter(
          (product) =>
            product.id !== id && // Exclude current product
            !similar.some((p) => p.id === product.id) && // Exclude similar products
            Math.abs(product.price - productPrice) <= productPrice * 0.2 // Within 20% price range
        )
        .slice(0, 3); // Limit to 3 products

      setSimilarProducts(similar);
      setLikeableProducts(likeable);
      setLoading(false);
    }
  }, [productDoc, allProducts, currencyDoc, id]);

  // Update handleAddToCart function
  const handleAddToCart = async () => {
    if (!user) {
      // if user is not logged in → redirect to login
      // THIS CODE BASICALLY IF USER LOGIN SO CAME BACK ON EXISTING PAGE
      navigate("/login", { state: { from: location } });
      return;
    }

    try {
      setIsAddingToCart(true);
      setError(null);

      // Check if product is in stock
      if (productDoc.stock <= 0) {
        throw new Error("Product is out of stock");
      }

      // Check quantity limits
      if (productDoc.maxQuantity && quantity > productDoc.maxQuantity) {
        throw new Error(
          `Maximum quantity allowed is ${productDoc.maxQuantity}`
        );
      }

      if (productDoc.minQuantity && quantity < productDoc.minQuantity) {
        throw new Error(
          `Minimum quantity required is ${productDoc.minQuantity}`
        );
      }

      // Add to cart the selected quantity number of times
      await addToCartFromDetails(
        id, // productId
        "", // size (null if not applicable)
        "", // color (null if not applicable)
        "", // variantName (null if not applicable)
        productDoc.price, // discountedPrice
        quantity,
        selectedDeliveryInterval || "",
        selectedFrequencyType,
        productSubscription,
        selectedDay || "",
        selectedDate || ""
      );
    } catch (err) {
      setError(err.message);
    } finally {
      setIsAddingToCart(false);
    }
  };

  // // Handler for buy now
  // const handleBuyNow = async () => {
  //   try {
  //     setIsAddingToCart(true);
  //     setError(null);

  //     // Same checks as add to cart
  //     if (productDoc.stock <= 0) {
  //       throw new Error("Product is out of stock");
  //     }

  //     if (productDoc.maxQuantity && quantity > productDoc.maxQuantity) {
  //       throw new Error(
  //         `Maximum quantity allowed is ${productDoc.maxQuantity}`
  //       );
  //     }

  //     if (productDoc.minQuantity && quantity < productDoc.minQuantity) {
  //       throw new Error(
  //         `Minimum quantity required is ${productDoc.minQuantity}`
  //       );
  //     }

  //     // Add to cart
  //     for (let i = 0; i < quantity; i++) {
  //       await addToCart(productDoc.id);
  //     }

  //     // ✅ Redirect dynamically using Firestore value
  //     const redirectUrl =
  //       checkoutBtnDoc?.checkoutBtnName?.redirectUrl || "/cart";
  //     navigate(redirectUrl);
  //   } catch (err) {
  //     setError(err.message);
  //   } finally {
  //     setIsAddingToCart(false);
  //   }
  // };

  // Handler for buy now
  const handleBuyNow = async () => {
    if (!user) {
      // if user is not logged in → redirect to login
      navigate("/login", {
        state: { from: { pathname: `/checkout/${productDoc.id}` } },
      });
      return;
    }

    try {
      setIsAddingToCart(true);
      setError(null);

      // Same checks as add to cart
      if (productDoc.stock <= 0) {
        throw new Error("Product is out of stock");
      }

      if (productDoc.maxQuantity && quantity > productDoc.maxQuantity) {
        throw new Error(
          `Maximum quantity allowed is ${productDoc.maxQuantity}`
        );
      }

      if (productDoc.minQuantity && quantity < productDoc.minQuantity) {
        throw new Error(
          `Minimum quantity required is ${productDoc.minQuantity}`
        );
      }

      await addToCartFromDetails(
        id, // productId
        "", // size (null if not applicable)
        "", // color (null if not applicable)
        "", // variantName (null if not applicable)
        productDoc.price, // discountedPrice
        quantity,
        selectedDeliveryInterval || "",
        selectedFrequencyType,
        productSubscription,
        selectedDay || "",
        selectedDate || ""
      );

      // ✅ Redirect dynamically using Firestore value
      let redirectUrl; // default

      if (checkoutBtnDoc?.checkoutBtnName?.redirectUrl) {
        if (checkoutBtnDoc.checkoutBtnName.redirectUrl === "/checkout") {
          redirectUrl = `/checkout/${productDoc.id}`;
        } else {
          redirectUrl = checkoutBtnDoc.checkoutBtnName.redirectUrl;
        }
      }

      navigate(redirectUrl);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsAddingToCart(false);
    }
  };

  // Handle errors
  if (productError || productsError || currencyError) {
    return (
      <div className="error-container">
        <p>Error loading product details. Please try again later.</p>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  // Show loading state
  if (loading || !productDoc || !currencyDoc) {
    return (
      <div className="loading-container">
        <PGLoaders />
      </div>
    );
  }

  // COPY NEW CREATED PRODUCT ID
  const handleCopyProductId = () => {
    if (productDoc?.productId) {
      navigator.clipboard.writeText(productDoc.productId);
      setSnackbarMessage("Id Copied!");
      setSnackbarOpen(true);
    }
  };

  // START CODE FOR WISTLIST PRODUCTS
  const findWishlistItem = (productId) => {
    return wishlistItems.find((item) => item.productId === productId);
  };

  // Check if product is in wishlist
  const isProductInWishlist = (productId) => {
    return wishlistItems?.some((item) => item.productId === productId) || false;
  };

  // Handle adding to wishlist
  const handleAddToWishlist = (productId) => {
    addToWishlist(productId);
    setSnackbarMessage("Added to Wishlist");
    setSnackbarOpen(true);
  };

  // Handle removing from wishlist
  const handleWishlistRemove = (wishlistItem) => {
    removeFromWishlist(wishlistItem.id);
    setSnackbarMessage("Removed from Wishlist");
    setSnackbarOpen(true);
  };
  // END CODE FOR WISTLIST PRODUCTS

  // START CODE FOR SHARE URL
  // Share product URL
  const shareURL = async () => {
    try {
      await navigator.share({
        title: productDoc.name,
        text: productDoc.short_description,
        url: window.location.href,
      });
    } catch (error) {
      console.error("Sharing failed:", error);
      // Fallback: Copy to clipboard
      navigator.clipboard.writeText(window.location.href);
      setSnackbarMessage("Link copied to clipboard!");
      setSnackbarOpen(true);
    }
  };

  // END CODE FOR SHARE URL
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false); // Close snackbar
  };

  // START CODE SUBSCRIPTION PRODUCT

  const handleSubscriptionChange = (e) => {
    const checked = e.target.checked;
    setProductSubscription(checked);

    // Reset fields when unchecked
    if (!checked) {
      setSelectedFrequencyType("");
      setSelectedDeliveryInterval("");
      setSelectedDay("");
      setSelectedDate("");
    }
  };
  const handleFrequencyTypeChange = (e) => {
    const type = e.target.value;
    setSelectedFrequencyType(type);

    // ✅ Auto-select defaults based on frequency type
    if (type === "month") {
      setSelectedDeliveryInterval("4 Months");
      setSelectedDay("");
    } else if (type === "week") {
      setSelectedDeliveryInterval("4 Week");
      setSelectedDay("Monday");
    }

    // Reset date for fresh selection
    setSelectedDate("");
  };

  const handleDeliveryIntervalChange = (e) => {
    setSelectedDeliveryInterval(e.target.value);
  };
  // END CODE SUBSCRIPTION PRODUCT

  // ✅ Calculate product average rating
  const validReviews = Array.isArray(productDoc?.reviews)
    ? productDoc.reviews.filter(
        (r) => r && typeof r.rating === "number" && r.rating > 0
      )
    : [];

  const totalRatings = validReviews.length;

  const averageRating = totalRatings
    ? (
        validReviews.reduce((sum, r) => sum + Number(r.rating), 0) /
        totalRatings
      ).toFixed(1)
    : 0;
  // end product rating

  // size functionality

  // const handleSizeVisibilityToggle = async () => {
  //   const newVisibility = !isSizeVisible;
  //   setIsSizeVisible(newVisibility);
  //   try {
  //     await updateDocument(productDoc, { showSizes: newVisibility });
  //   } catch (error) {
  //     console.error("Error updating size visibility:", error);
  //   }
  // };

  const handleOpenSizeModal = () => {
    setIsSizeModalOpen(true);
  };

  const handleCloseSizeModal = () => {
    setIsSizeModalOpen(false);
    setSize("");
    setSizeUrl("");
  };

  const handleSelectedSize = (sizeObj) => {
    if (sizeObj.sizeUrl) {
      const trimmedUrl = sizeObj.sizeUrl.trim();

      if (!trimmedUrl) {
        setSelectedSize(sizeObj);
        return;
      }

      const appBaseUrl = window.location.origin;

      try {
        const url = new URL(trimmedUrl, appBaseUrl);
        const isInternal = url.origin === appBaseUrl;

        if (isInternal) {
          const relativePath = url.pathname + url.search + url.hash;
          navigate(relativePath, { replace: false });
        } else {
          setSnackbarMessage("Navigating to external site...");
          setSnackbarOpen(true);
          window.location.assign(trimmedUrl);
        }
      } catch (error) {
        console.error("Invalid URL:", trimmedUrl, error);
        setSnackbarMessage("Invalid URL provided");
        setSnackbarOpen(true);
        setSelectedSize(sizeObj);
      }
    } else {
      setSelectedSize(sizeObj);
    }
  };

  const handleSaveSize = async () => {
    try {
      const newSize = {
        size,
        sizeUrl: sizeUrl.trim() || "",
      };
      const updatedSizes = productDoc.sizes
        ? [...productDoc.sizes, newSize]
        : [newSize];
      await updateDocument(id, { sizes: updatedSizes });
      handleCloseSizeModal();
    } catch (error) {
      console.error("Error adding size:", error);
    }
  };

  const handleDeleteSize = async (sizeToDelete) => {
    try {
      const updatedSizes = productDoc.sizes.filter((size, index) => {
        return size !== sizeToDelete;
      });
      await updateDocument(id, { sizes: updatedSizes });
    } catch (err) {
      console.log("Error deleting size:", err);
    }
  };

  // variants functionality

  const handleVariantClick = (variant) => {
    if (variant.variantUrl) {
      const trimmedUrl = variant.variantUrl.trim();
      // Skip if URL is empty
      if (!trimmedUrl) {
        setSelectedVariant(variant);
        return;
      }
      // Get the app's base URL (replace with your app's domain)
      const appBaseUrl = window.location.origin; // e.g., "https://yourapp.com"

      try {
        // Parse the URL
        const url = new URL(trimmedUrl, appBaseUrl); // Handles both relative and absolute URLs
        const isInternal = url.origin === appBaseUrl; // Check if URL is within your app

        if (isInternal) {
          // Extract the pathname for client-side navigation
          const relativePath = url.pathname + url.search + url.hash;
          navigate(relativePath, { replace: false }); // Client-side navigation, no reload
        } else {
          // For external URLs, open in same tab (will reload, but warn user if needed)
          setSnackbarMessage("Navigating to external site...");
          setSnackbarOpen(true);
          window.location.assign(trimmedUrl); // Fallback for external URLs
        }
      } catch (error) {
        console.error("Invalid URL:", trimmedUrl, error);
        setSnackbarMessage("Invalid URL provided");
        setSnackbarOpen(true);
        setSelectedVariant(variant); // Fallback to selecting variant
      }
    } else {
      setSelectedVariant(variant);
    }
  };

  const handleVariantModalOpen = () => {
    setIsVariantModalOpen(true);
  };

  const handleVariantModalClose = () => {
    setIsVariantModalOpen(false);
  };

  const handleVariantChange = (e) => {
    const { name, value } = e.target;
    setVariantInfo({ ...variantInfo, [name]: value });
  };

  // Update variant save handler
  const handleSaveVariant = async () => {
    // ✅ Validation — stop if any field is missing
    if (
      !variantInfo.variantName ||
      !variantInfo.variantPrice ||
      !variantInfo.variantUrl
    ) {
      setSnackbarOpen(true);
      setSnackbarMessage("Please fill all variant fields before saving.");
      return;
    }

    try {
      const newVariant = productDoc.variants
        ? [
            ...productDoc.variants,
            {
              variantName: variantInfo.variantName,
              variantPrice: variantInfo.variantPrice,
              variantUrl: variantInfo.variantUrl,
            },
          ]
        : [
            {
              variantName: variantInfo.variantName,
              variantPrice: variantInfo.variantPrice,
              variantUrl: variantInfo.variantUrl,
            },
          ];

      await updateDocument(id, { variants: newVariant });

      // ✅ Reset fields
      setVariantInfo({ variantName: "", variantPrice: "", variantUrl: "" });

      // ✅ Close modal
      handleVariantModalClose();
    } catch (err) {
      console.error("Error adding new Variant:", err);
    }
  };

  const handleDeleteVariant = async (variantToDelete) => {
    try {
      const updatedVariants = productDoc.variants.filter((variant, index) => {
        return variant !== variantToDelete;
      });
      await updateDocument(id, { variants: updatedVariants });
    } catch (err) {
      console.log("Error deleting variant:", err);
    }
  };

  // Convert vendor IDs from productDoc.showProductTo into vendor names
  // Convert vendor IDs from productDoc.showProductTo into vendor names
  const vendorNames = (() => {
    if (!productDoc?.showProductTo || !vendors) return [];

    // If "all" is selected → return special message
    if (productDoc.showProductTo.includes("all")) {
      return "all_outlets"; // special flag
    }

    // Otherwise match against vendor documents
    return vendors
      .filter((v) => productDoc.showProductTo.includes(v.id))
      .map((v) => v.name);
  })();

  return (
    <div className="product-detail">
      {/* START MODEL FOR EDIT PRODUCT DETAILS */}
      {editField && (
        <EditProductDetails
          open={isEditModalOpen}
          onClose={handleCloseEditModal}
          field={editField}
        />
      )}

      {/* END MODEL FOR EDIT PRODUCT DETAILS */}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{
            width: "120%",
            backgroundColor: "white",
            border: "1px solid black",
          }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* Main Product Container */}
      <div className="product-detail__container">
        <div className="product-detail__gallery">
          <div className="gallery-container">
            <div className="product-detail-two__thumbnails">
              {productDoc.images.map((image, index) => (
                <div
                  key={index}
                  className={`thumbnail ${
                    activeImage === index ? "active" : ""
                  }`}
                  onClick={() => setActiveImage(index)}
                >
                  <img
                    src={image}
                    alt={`${productDoc.name} view ${index + 1}`}
                  />
                  <DeleteProductImage
                    isOpen={isDeleteModalOpen}
                    onClose={() => setIsDeleteModalOpen(false)}
                    imageURL={imageToDelete}
                    productId={productDoc.id}
                    onSuccess={(deletedImageURL) => {
                      // Remove from local UI instantly
                      const updatedImages = productDoc.images.filter(
                        (img) => img !== deletedImageURL
                      );
                      productDoc.images = updatedImages;

                      // Reset activeImage if needed
                      setActiveImage((prev) =>
                        prev >= updatedImages.length ? 0 : prev
                      );

                      // Optional: show snackbar
                      setSnackbarMessage("Image deleted successfully!");
                      setSnackbarOpen(true);
                    }}
                    onError={(err) => {
                      console.error(err);
                      setSnackbarMessage("Failed to delete image.");
                      setSnackbarOpen(true);
                    }}
                  />
                </div>
              ))}

              {/* Add New Image Button */}
              {(appTypeDoc?.apptype === "lite" && isSuperAdmin) ||
              (appTypeDoc?.apptype === "pro" && (isSuperAdmin || isAdmin)) ? (
                <div
                  className="thumbnail add-new-image"
                  onClick={() => {
                    const fileInput = document.createElement("input");
                    fileInput.type = "file";
                    fileInput.accept = "image/*";
                    fileInput.click();

                    fileInput.onchange = async (e) => {
                      const file = e.target.files[0];
                      if (!file) return;
                      setIsUploading(true); // Start loader

                      try {
                        // Upload to Firebase Storage
                        const storageRef = firebase.storage().ref();
                        const fileRef = storageRef.child(
                          `product_img/${id}/${file.name}_${Date.now()}`
                        );
                        await fileRef.put(file);
                        const downloadURL = await fileRef.getDownloadURL();

                        // Update Firestore product document
                        const productRef = firebase
                          .firestore()
                          .collection("products")
                          .doc(id);
                        await productRef.update({
                          images:
                            firebase.firestore.FieldValue.arrayUnion(
                              downloadURL
                            ),
                        });

                        // Update UI instantly
                        setActiveImage(productDoc.images.length); // set newly uploaded image as active
                        productDoc.images.push(downloadURL); // update local productDoc for immediate UI update

                        setSnackbarMessage("Image uploaded successfully!");
                        setSnackbarOpen(true);
                      } catch (err) {
                        console.error("Image upload error:", err);
                        setSnackbarMessage("Failed to upload image.");
                        setSnackbarOpen(true);
                      } finally {
                        setIsUploading(false); // Stop loader
                      }
                    };
                  }}
                >
                  {isUploading ? (
                    <div className="loader"></div> // Loader shown only during upload
                  ) : (
                    <span className="plus-icon">+</span>
                  )}
                </div>
              ) : null}
            </div>
            {/* 
              {appTypeDoc &&
                appTypeDoc.apptype === "pro" &&
                (isSuperAdmin || isAdmin) && (
                  <div
                    className="thumbnail add-new-image"
                    onClick={() => {
                      const fileInput = document.createElement("input");
                      fileInput.type = "file";
                      fileInput.accept = "image/*";
                      fileInput.click();
                      fileInput.onchange = (e) => {
                        const file = e.target.files[0];
                        if (file) {
                          console.log("Selected file:", file);
                        }
                      };
                    }}
                  >
                    <span className="plus-icon">+</span>
                  </div>
                )}
            </div> */}
            <div className="product-detail__main-image">
              <img src={productDoc.images[activeImage]} alt={productDoc.name} />

              {isSuperAdmin &&
                (appTypeDoc?.apptype === "lite" ||
                  appTypeDoc?.apptype === "pro") && (
                  <button
                    className="delete-image-btn"
                    onClick={() => {
                      setImageToDelete(productDoc.images[activeImage]);
                      setIsDeleteModalOpen(true);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="currentColor"
                    >
                      <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
                    </svg>
                  </button>
                )}

              {productDoc && productDoc.productId && (
                <p
                  className="product-id-n-gallery-img"
                  onClick={handleCopyProductId}
                  style={{ cursor: "pointer" }}
                  title="Click to copy ID"
                >
                  {productDoc && productDoc.productId}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="product-detail__info">
          {/* Category Chip */}
          {productDetailsVisibility &&
            productDetailsVisibility.productCategory && (
              <div className="product-category-chips">
                {productDoc.category.map((cat, index) => (
                  <span key={index} className="category-chip">
                    {cat}
                  </span>
                ))}
                {productDoc.subCategory.map((subCat, index) => (
                  <span key={index} className="category-chip">
                    {subCat}
                  </span>
                ))}
              </div>
            )}
          {productDetailsVisibility && productDetailsVisibility.productName && (
            <h1 className="product-detail__title">
              {productDoc.name}&nbsp;
              {user &&
                (user.role === "admin" || user.role === "superAdmin") && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    width="24px"
                    viewBox="0 -960 960 960"
                    fill="currentColor"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleOpenEditModal("name")}
                  >
                    <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z" />
                  </svg>
                )}
            </h1>
          )}
          {multiLocation && multiLocation.isEnabled && (
            <div className="vendor-outlet-wrapper">
              <div className="vendor-outlet-container">
                <div className="vendor-outlet-label">Locations:</div>
                <div className="vendor-outlet-value">
                  {vendorNames === "all_outlets" ? (
                    <span className="vendor-outlet-badge vendor-outlet-badge-all">
                      Available for all Locations
                    </span>
                  ) : vendorNames.length > 0 ? (
                    vendorNames.map((name, index) => (
                      <span key={index} className="vendor-outlet-badge">
                        {name}
                      </span>
                    ))
                  ) : (
                    <span className="vendor-outlet-badge vendor-outlet-badge-empty">
                      No vendors assigned
                    </span>
                  )}

                  {user &&
                    (user.role === "admin" || user.role === "superAdmin") && (
                      <svg
                        className="vendor-outlet-edit-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        height="22px"
                        width="22px"
                        viewBox="0 -960 960 960"
                        fill="currentColor"
                        onClick={() => handleOpenEditModal("vendorLocation")}
                      >
                        <path
                          d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 
          23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 
          33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 
          27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 
          29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 
          56 56ZM440-440h56l232-232-28-28-29-28-231 
          231v57Zm260-260-29-28 29 28 28 28-28-28Z"
                        />
                      </svg>
                    )}
                </div>
              </div>
              <br />
            </div>
          )}

          {/* Rating Section with Star Icon */}
          {productDetailsVisibility &&
            productDetailsVisibility.productRating && (
              <div className="product-rating-badge">
                <span className="rating-star">
                  <span className="material-symbols-outlined">star</span>
                  {productDoc?.rating ?? "0"}
{/* Firebase productDoc se rating aa rahi hai */}

                </span>
                {user &&
                  (user.role === "admin" || user.role === "superAdmin") && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      width="24px"
                      viewBox="0 -960 960 960"
                      fill="currentColor"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleOpenEditModal("rating")}
                    >
                      <path
                        d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 
                       23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358
                       q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170
                       l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57
                       q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424
                       -56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260
                       -29-28 29 28 28 28-28-28Z"
                      />
                    </svg>
                  )}
                <span className="rating-count">
                  {Array.isArray(productDoc?.reviews)
                    ? productDoc.reviews.filter(
                        (r) => r?.review && r.review.trim().length > 0
                      ).length
                    : 0}{" "}
                  Reviews
                </span>

                {/* Wishlist Button */}
                {isProductInWishlist(productDoc.id) ? (
                  <button
                    onClick={() =>
                      handleWishlistRemove(findWishlistItem(productDoc.id))
                    }
                    className="wishlist-btn"
                    title="Remove from Wishlist"
                  >
                    {/* Filled red heart SVG */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 0 24 24"
                      width="24px"
                      fill="red"
                    >
                      <path
                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
                    2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 
                    4.5 2.09C13.09 3.81 14.76 3 16.5 3 
                    19.58 3 22 5.42 22 8.5c0 3.78-3.4 
                    6.86-8.55 11.54L12 21.35z"
                      />
                    </svg>
                  </button>
                ) : (
                  <button
                    onClick={() => handleAddToWishlist(productDoc.id)}
                    className="wishlist-btn"
                    title="Add to Wishlist"
                  >
                    {/* Outline black heart SVG */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 0 24 24"
                      width="24px"
                      fill="none"
                      stroke="black"
                      strokeWidth="2"
                    >
                      <path
                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
                    2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 
                    4.5 2.09C13.09 3.81 14.76 3 16.5 3 
                    19.58 3 22 5.42 22 8.5c0 3.78-3.4 
                    6.86-8.55 11.54L12 21.35z"
                      />
                    </svg>
                  </button>
                )}

                <span
                  className="material-symbols-outlined share-icon"
                  onClick={shareURL}
                  style={{
                    cursor: "pointer",
                    marginLeft: "3px",
                    fontSize: "22px",
                  }}
                  title="Share this product"
                >
                  share
                </span>
              </div>
            )}
          <div className="product-detail__pricing">
            {productDetailsVisibility &&
              productDetailsVisibility.productPrice && (
                <div className="current-price">
                  {(() => {
                    const finalPriceWithGST = productDoc?.price || 0; // stored price is inclusive of GST
                    const gstValue =
                      productDoc?.gst !== undefined &&
                      productDoc?.gst !== null &&
                      productDoc?.gst !== ""
                        ? parseFloat(productDoc?.gst)
                        : parseFloat(TAXDocument?.gst || 0);

                    const hasValidGST = !isNaN(gstValue) && gstValue > 0;

                    // Reverse calculation: Base Price before GST
                    {
                      /* const basePrice = hasValidGST
                      ? Math.round(finalPriceWithGST / (1 + gstValue / 100))
                      : finalPriceWithGST; */
                    }
                    return (
                      <div className="d-flex align-items-center div-gst-with-price">
                        {currencyDoc.symbol}
                        {finalPriceWithGST}
                      </div>
                    );
                  })()}
                </div>
              )}
            {productDetailsVisibility &&
              productDetailsVisibility.productDiscount &&
              Number(productDoc.discount) > 0 && (
                <>
                  &nbsp;
                  <div className="original-price">
                    {currencyDoc.symbol}
                    {Math.ceil(
                      productDoc.price / (1 - Number(productDoc.discount) / 100)
                    )}
                  </div>
                  <div className="discount">
                    {`${productDoc.discount}% OFF`}
                  </div>
                </>
              )}

            <div className="current-price">
              {(() => {
                const finalPriceWithGST = productDoc?.price || 0; // stored price is inclusive of GST
                const gstValue =
                  productDoc?.gst !== undefined &&
                  productDoc?.gst !== null &&
                  productDoc?.gst !== ""
                    ? parseFloat(productDoc?.gst)
                    : parseFloat(TAXDocument?.gst || 0);

                const hasValidGST = !isNaN(gstValue) && gstValue > 0;

                // Reverse calculation: Base Price before GST
                const basePrice = hasValidGST
                  ? Math.round(finalPriceWithGST / (1 + gstValue / 100))
                  : finalPriceWithGST;
                return (
                  <div className="d-flex align-items-center">
                    <Popup
                      trigger={
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="22px"
                            viewBox="0 -960 960 960"
                            width="22px"
                            fill="grey"
                            style={{ marginTop: "-5px" }}
                          >
                            <path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                          </svg>
                        </div>
                      }
                      position="bottom"
                      on="hover"
                    >
                      <div className="userlist-popup-parent-div">
                        <div
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            borderRadius: "7px",
                            padding: "15px",
                          }}
                        >
                          <strong style={{ fontSize: "17px" }}>
                            Price Details
                          </strong>
                          <br />
                          <p style={{ fontSize: "15px" }}>
                            Price before GST <b>₹{basePrice}</b>
                          </p>
                          <p style={{ fontSize: "15px" }}>
                            GST ({gstValue}%){" "}
                            <b>₹{finalPriceWithGST - basePrice}</b>
                          </p>
                          <p style={{ fontSize: "15px" }}>
                            Maximum Retail Price <b>₹{finalPriceWithGST}</b>
                          </p>
                          <span style={{ fontSize: "14px", color: "grey" }}>
                            (Inclusive of all taxes)
                          </span>
                        </div>
                      </div>
                    </Popup>
                  </div>
                );
              })()}
            </div>

            {user && (user.role === "admin" || user.role === "superAdmin") && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                width="24px"
                viewBox="0 -960 960 960"
                fill="currentColor"
                style={{ cursor: "pointer" }}
                onClick={() => handleOpenEditModal("price_discount_gift")}
              >
                <path
                  d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 
                       23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358
                       q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170
                       l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57
                       q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424
                       -56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260
                       -29-28 29 28 28 28-28-28Z"
                />
              </svg>
            )}
          </div>

          {/* Product short description */}
          {productDetailsVisibility &&
            productDetailsVisibility.productShortDescription && (
              <div className="product-detail__description">
                <p>
                  {productDoc.short_description}
                  {user &&
                    (user.role === "admin" || user.role === "superAdmin") && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        width="24px"
                        viewBox="0 -960 960 960"
                        fill="currentColor"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenEditModal("short_description")}
                      >
                        <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z" />
                      </svg>
                    )}
                </p>
              </div>
            )}

          {/* Size Selector */}
          {/* <div className="product-detail__sizes">
            <h3>Select Size</h3>
            <div className="size-options">
              {["S", "M", "L", "XL"].map((size) => (
                <button
                  key={size}
                  className={`size-btn${
                    selectedSize === size ? " active" : ""
                  }`}
                  onClick={() => setSelectedSize(size)}
                  type="button"
                >
                  {size}
                </button>
              ))}
            </div>
          </div> */}

          {/* Color Selector */}
          {/* <div className="product-detail__colors">
            <h3>Select Color</h3>
            <div className="color-options">
              {[
                { name: "Red", code: "#e53935" },
                { name: "Blue", code: "#1e88e5" },
                { name: "Green", code: "#43a047" },
                { name: "Black", code: "#222" },
              ].map((color) => (
                <button
                  key={color.name}
                  className={`color-btn${
                    selectedColor === color.name ? " active" : ""
                  }`}
                  style={{ backgroundColor: color.code }}
                  onClick={() => setSelectedColor(color.name)}
                  type="button"
                  title={color.name}
                >
                  {selectedColor === color.name && (
                    <span className="material-symbols-outlined">check</span>
                  )}
                </button>
              ))}
            </div>
          </div> */}

          {/* Pincode Checker */}
          {productDetailsVisibility &&
            productDetailsVisibility.deliverablePincodes && (
              <div className="pincode-checker">
                <h4>Check Product Availability</h4>
                <div className="pincode-input-group">
                  <input
                    type="text"
                    value={pincode}
                    onChange={(e) => setPincode(e.target.value)}
                    placeholder="Enter delivery pincode"
                    maxLength="6"
                  />
                  <button
                    className="check-pincode-btn"
                    onClick={() => {
                      // Add pincode checking logic here
                      console.log("Checking pincode:", pincode);
                    }}
                  >
                    Check
                  </button>
                </div>
                {pincode && (
                  <p className="delivery-status">
                    <span className="material-symbols-outlined">
                      local_shipping
                    </span>
                    Delivery available in your area
                  </p>
                )}
              </div>
            )}

          {/* SUBSCIPTION CODE START */}
          <div className="subscribe-save-container">
            {productDoc.productType === "subscription" && (
              <div className="subscribe-save-card">
                <label className="subscribe-save-toggle">
                  <input
                    type="checkbox"
                    checked={productSubscription}
                    onChange={handleSubscriptionChange}
                  />
                  <span className="subscribe-save-slider"></span>
                  <span className="subscribe-save-label-text">
                    Subscribe & Save
                  </span>
                </label>

                {productSubscription && (
                  <div className="subscribe-save-content">
                    {/* Frequency Selection */}
                    <div className="subscribe-save-frequency">
                      <label className="subscribe-save-radio">
                        <input
                          type="radio"
                          value="month"
                          checked={selectedFrequencyType === "month"}
                          onChange={handleFrequencyTypeChange}
                        />
                        <span>Month</span>
                      </label>

                      <label className="subscribe-save-radio">
                        <input
                          type="radio"
                          value="week"
                          checked={selectedFrequencyType === "week"}
                          onChange={handleFrequencyTypeChange}
                        />
                        <span>Week</span>
                      </label>
                    </div>

                    {/* Options */}
                    <div className="subscribe-save-options">
                      {selectedFrequencyType === "week" && (
                        <div className="subscribe-save-select">
                          <label>Duration</label>
                          <select
                            value={selectedDeliveryInterval}
                            onChange={handleDeliveryIntervalChange}
                          >
                            <option>Select week</option>
                            <option value="4 Week">4 Week</option>
                            <option value="6 Week">6 Week</option>
                            <option value="8 Week">8 Week</option>
                          </select>
                        </div>
                      )}

                      {selectedFrequencyType === "month" && (
                        <div className="subscribe-save-select">
                          <label>Duration</label>
                          <select
                            value={selectedDeliveryInterval}
                            onChange={handleDeliveryIntervalChange}
                          >
                            <option value="4 Months">
                              4 Months (Most common)
                            </option>
                            <option value="5 Months">5 Months</option>
                            <option value="6 Months">6 Months</option>
                          </select>
                        </div>
                      )}

                      {/* Weekly Day Selector */}
                      {selectedDeliveryInterval.includes("Week") && (
                        <div className="subscribe-save-select">
                          <label>Choose delivery day</label>
                          <select
                            value={selectedDay}
                            onChange={(e) => setSelectedDay(e.target.value)}
                          >
                            <option value="">Select day</option>
                            <option value="Monday">Monday</option>
                            <option value="Tuesday">Tuesday</option>
                            <option value="Wednesday">Wednesday</option>
                            <option value="Thursday">Thursday</option>
                            <option value="Friday">Friday</option>
                            <option value="Saturday">Saturday</option>
                            <option value="Sunday">Sunday</option>
                          </select>
                        </div>
                      )}

                      {/* Monthly Date Picker */}
                      {selectedDeliveryInterval.includes("Month") && (
                        <div className="subscribe-save-select">
                          <label>Choose delivery date</label>

                          <div className="subscribe-save-date-picker">
                            <div
                              className="subscribe-save-date-display"
                              onClick={() => setShowCalendar((prev) => !prev)}
                            >
                              {selectedDate ? `${selectedDate}` : "Select date"}
                              <span className="material-symbols-outlined">
                                calendar_month
                              </span>
                            </div>

                            {showCalendar && (
                              <div className="subscribe-save-calendar-popup">
                                {[...Array(28)].map((_, i) => {
                                  const day = String(i + 1).padStart(2, "0");

                                  // derive currently-selected day (always compare day-of-month as 2-digit string)
                                  const selectedDayStr =
                                    typeof selectedDate === "string" &&
                                    selectedDate.includes("-")
                                      ? selectedDate
                                          .split("-")
                                          .pop()
                                          .padStart(2, "0")
                                      : selectedDate !== null &&
                                        selectedDate !== undefined
                                      ? String(selectedDate).padStart(2, "0")
                                      : "";

                                  const isActive = selectedDayStr === day;

                                  return (
                                    <div
                                      key={i}
                                      className={`subscribe-save-date-cell ${
                                        isActive ? "active" : ""
                                      }`}
                                      onClick={() => {
                                        // store full date as YYYY-MM-DD (month = current month)
                                        const today = new Date();
                                        const year = today.getFullYear();
                                        const month = String(
                                          today.getMonth() + 1
                                        ).padStart(2, "0");
                                        const selectedFullDate = `${year}-${month}-${day}`;
                                        setSelectedDate(selectedFullDate);
                                        setShowCalendar(false);
                                      }}
                                    >
                                      {i + 1}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* ✅ Subscription Summary Table */}
                    <div className="subscribe-save-summary">
                      <h4>Subscription Schedule</h4>
                      <table className="subscribe-save-table">
                        <thead>
                          <tr>
                            <th>Estimated Delivery Date</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            const rows = [];
                            const total =
                              parseInt(
                                selectedDeliveryInterval?.match?.(/\d+/)?.[0],
                                10
                              ) || 0;

                            // Helpers
                            const daysOfWeek = [
                              "Sunday",
                              "Monday",
                              "Tuesday",
                              "Wednesday",
                              "Thursday",
                              "Friday",
                              "Saturday",
                            ];

                            const parseSelectedDayOfMonth = (sel) => {
                              if (!sel && sel !== 0) return NaN;
                              // YYYY-MM-DD -> extract day
                              if (
                                typeof sel === "string" &&
                                sel.includes("-")
                              ) {
                                const parts = sel.split("-");
                                return parseInt(parts[2], 10);
                              }
                              // number or numeric string
                              return Number(sel);
                            };

                            // Compute a reliable base date for monthly schedule
                            const computeMonthlyBaseDate = (sel) => {
                              const today = new Date();
                              today.setHours(0, 0, 0, 0);

                              // If user supplied full date string (YYYY-MM-DD), use that directly
                              if (
                                typeof sel === "string" &&
                                sel.includes("-")
                              ) {
                                const candidate = new Date(sel);
                                candidate.setHours(0, 0, 0, 0);
                                // If candidate is invalid, fallback to today
                                if (!isNaN(candidate.getTime()))
                                  return candidate;
                              }

                              // Otherwise use day-of-month relative to today
                              const dayNum = parseSelectedDayOfMonth(sel);
                              if (isNaN(dayNum) || dayNum < 1 || dayNum > 31) {
                                // fallback: 1st of next week
                                const fallback = new Date(today);
                                fallback.setDate(today.getDate() + 7);
                                return fallback;
                              }

                              // try this month with that day
                              const thisMonthCandidate = new Date(
                                today.getFullYear(),
                                today.getMonth(),
                                dayNum
                              );
                              // If that date already passed (strictly < today), move to next month
                              if (thisMonthCandidate < today) {
                                const nextMonthCandidate = new Date(
                                  today.getFullYear(),
                                  today.getMonth() + 1,
                                  dayNum
                                );
                                // handle overflow (e.g., Feb 30) -> set to last day of month
                                if (nextMonthCandidate.getDate() !== dayNum) {
                                  nextMonthCandidate.setDate(0); // last day of previous month (intended month)
                                }
                                return nextMonthCandidate;
                              } else {
                                // if day exists in this month (handles overflow automatically because Date(...) will roll)
                                if (thisMonthCandidate.getDate() !== dayNum) {
                                  // overflow (e.g., Feb 30) -> set to last day of this month
                                  const lastDayThisMonth = new Date(
                                    today.getFullYear(),
                                    today.getMonth() + 1,
                                    0
                                  );
                                  return lastDayThisMonth;
                                }
                                return thisMonthCandidate;
                              }
                            };

                            // Add months to a base date safely (handles month-end rollover)
                            const addMonthsSafe = (baseDate, monthsToAdd) => {
                              const d = new Date(baseDate.getTime());
                              const day = baseDate.getDate();
                              d.setMonth(d.getMonth() + monthsToAdd);

                              // if day overflowed (e.g., Feb doesn't have 31), clamp to last day of month
                              if (d.getDate() !== day) {
                                d.setDate(0);
                              }
                              return d;
                            };

                            // Weekly next weekday from a start date
                            const getNextWeekdayDate = (
                              dayName,
                              startDate,
                              weekOffset = 0
                            ) => {
                              const target = daysOfWeek.indexOf(dayName);
                              if (target === -1) return null;
                              const base = new Date(startDate.getTime());
                              base.setHours(0, 0, 0, 0);
                              const diff = (target - base.getDay() + 7) % 7;
                              const addDays = diff + weekOffset * 7;
                              base.setDate(base.getDate() + addDays);
                              return base;
                            };

                            // Determine price numeric
                            const price = Number(productDoc?.price) || 0;

                            // Monthly schedule
                            if (
                              selectedFrequencyType === "month" &&
                              selectedDate
                            ) {
                              const base = computeMonthlyBaseDate(selectedDate);
                              for (let i = 0; i < total; i++) {
                                const nextDate = addMonthsSafe(base, i);
                                rows.push(
                                  <tr key={`m-${i}`}>
                                    <td>
                                      {nextDate.toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })}
                                    </td>
                                    <td>₹{price.toFixed(2)}</td>
                                  </tr>
                                );
                              }
                            }

                            // Weekly schedule
                            else if (
                              selectedFrequencyType === "week" &&
                              selectedDay
                            ) {
                              const start = new Date();
                              start.setHours(0, 0, 0, 0);
                              for (let i = 0; i < total; i++) {
                                const nextDate = getNextWeekdayDate(
                                  selectedDay,
                                  start,
                                  i
                                );
                                if (!nextDate) continue;
                                rows.push(
                                  <tr key={`w-${i}`}>
                                    <td>
                                      {nextDate.toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })}
                                    </td>
                                    <td>₹{price.toFixed(2)}</td>
                                  </tr>
                                );
                              }
                            }

                            return rows.length ? (
                              rows
                            ) : (
                              <tr>
                                <td colSpan={2}>No schedule available</td>
                              </tr>
                            );
                          })()}
                        </tbody>
                      </table>

                      <p className="subscribe-save-note">
                        💡 Pay once for full subscription using online payment,
                        or pay each delivery with COD.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* <div className="size-guide-container">
            <span className="material-symbols-outlined">info</span>
            <span
              className="size-guide-link"
              onClick={() => setIsSizeGuideOpen(true)}
            >
              Size Guide
            </span>
            <Modal
              open={isSizeGuideOpen}
              onClose={() => setIsSizeGuideOpen(false)}
              aria-labelledby="size-guide-modal-title"
              aria-describedby="size-guide-modal-description"
            >
              <Box
                sx={{
                  ...modalStyle,
                  width: "95%",
                  maxWidth: 700,
                  minWidth: 320,
                }}
              >
                <div className="size-guide-modal-header">
                  <h2 id="size-guide-modal-title">Women's Size Guide</h2>
                  <div className="size-guide-tabs">
                    <span
                      className={`tab-btn${
                        sizeGuideTab === "inch" ? " active" : ""
                      }`}
                      onClick={() => setSizeGuideTab("inch")}
                    >
                      Inch
                    </span>
                    <span
                      className={`tab-btn${
                        sizeGuideTab === "cm" ? " active" : ""
                      }`}
                      onClick={() => setSizeGuideTab("cm")}
                    >
                      CM
                    </span>
                  </div>
                </div>
                <div className="size-guide-table-wrapper">
                  <table className="size-guide-table">
                    <thead>
                      <tr>
                        <th>General Size</th>
                        <th>
                          {sizeGuideTab === "inch"
                            ? "Size (Inch)"
                            : "Size (CM)"}
                        </th>
                        <th>Chest</th>
                        <th>Waist</th>
                        <th>Hip</th>
                        <th>Across Shoulder</th>
                        <th>Front Length</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(sizeGuideTab === "inch"
                        ? sizeGuideInchData
                        : sizeGuideCmData
                      ).map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.general}</td>
                          <td>{row.size}</td>
                          <td>{row.chest}</td>
                          <td>{row.waist}</td>
                          <td>{row.hip}</td>
                          <td>{row.shoulder}</td>
                          <td>{row.length}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Box>
            </Modal>
          </div> */}

          {productDoc?.showSizes && (
            <div className="product-detail__sizes">
              <div className="size-options">
                {productDoc &&
                  productDoc.sizes &&
                  productDoc.sizes.map((sizeObj, index) => (
                    <div
                      key={index}
                      className={`size-btn ${
                        selectedSize?.size === sizeObj.size
                          ? "selected-size"
                          : ""
                      }`}
                      onClick={() => handleSelectedSize(sizeObj)}
                    >
                      <span className="size-name">{sizeObj.size}</span>
                      {user && user.role === "admin" && (
                        <span
                          className="material-symbols-outlined"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteSize(sizeObj);
                          }}
                        >
                          close
                        </span>
                      )}
                    </div>
                  ))}
                {user && user.role === "admin" && (
                  <button
                    className="add-size-btn"
                    onClick={handleOpenSizeModal}
                  >
                    <span className="material-symbols-outlined">add</span>
                  </button>
                )}
              </div>
            </div>
          )}

          {/* VARIENTS CODE START */}
          {productDoc?.showVariants && (
            <>
              <div className="variants-container">
                {productDoc &&
                  productDoc.variants &&
                  productDoc.variants.map((variant, index) => (
                    <div
                      key={index}
                      className={`variant-capsule ${
                        selectedVariant?.variantName === variant.variantName
                          ? "variant_btn_checked"
                          : ""
                      }`}
                      onClick={() => handleVariantClick(variant)}
                    >
                      <span className="variant-name">
                        {variant.variantName}
                      </span>
                      <span className="variant-price">
                        {currencyDocument.symbol} {variant.variantPrice}
                      </span>
                      {user && user.role === "admin" && (
                        <span
                          className="material-symbols-outlined"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteVariant(variant);
                          }}
                        >
                          close
                        </span>
                      )}
                    </div>
                  ))}
                {user && user.role === "admin" && (
                  <button
                    className="add-color-btn"
                    onClick={handleVariantModalOpen}
                  >
                    <span className="material-symbols-outlined">add</span>
                  </button>
                )}
              </div>
              <br />
            </>
          )}

          {/* Quantity selector and Add to Cart */}
          <div className="product-detail__actions">
            {/* Quantity Selector: Only show if cart feature is enabled */}
            {pageControlDoc?.cart && (
              <div className="quantity-selector">
                <button
                  className="quantity-btn"
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  disabled={quantity <= 1 || isAddingToCart}
                >
                  -
                </button>
                <input
                  type="number"
                  value={quantity}
                  onChange={(e) =>
                    setQuantity(Math.max(1, parseInt(e.target.value) || 1))
                  }
                  disabled={isAddingToCart}
                />
                <button
                  className="quantity-btn"
                  onClick={() => setQuantity(quantity + 1)}
                  disabled={
                    (productDoc.maxQuantity &&
                      quantity >= productDoc.maxQuantity) ||
                    quantity >= productDoc.stock ||
                    isAddingToCart
                  }
                >
                  +
                </button>
              </div>
            )}
            {productDoc.giftAllow && (
              <p style={{ fontSize: "15px" }} className="mb-3">
                🎁 Gift Wrap Available for This Product!{" "}
              </p>
            )}
            {/* Show error if any */}
            {error && <div className="error-message">{error}</div>}

            {/* Purchase Buttons */}
            <div className="purchase-buttons">
              {/* {user ? ( */}
              <>
                {/* Add to Cart / Go to Cart: Only if cart feature is enabled */}
                {pageControlDoc?.cart && cartQuantity > 0 && (
                  <button
                    className="go-to-cart-btn"
                    onClick={() => navigate("/cart")}
                  >
                    Go to Cart
                  </button>
                )}

                {pageControlDoc?.cart && cartQuantity === 0 && (
                  <button
                    className={`add-to-cart-btn ${
                      isAddingToCart ? "loading" : ""
                    }`}
                    onClick={handleAddToCart}
                    disabled={isAddingToCart || productDoc.stock <= 0}
                  >
                    {isAddingToCart ? (
                      "Adding..."
                    ) : productDoc.stock <= 0 ? (
                      "Out of Stock"
                    ) : (
                      <FiShoppingCart size={18} />
                    )}
                    {/* //  (checkoutBtnDoc &&
                      //     checkoutBtnDoc?.cartBtnName.btnName) || 
                      //   "Buy Now"} */}
                  </button>
                )}

                {pageControlDoc?.checkOut && (
                  <button
                    className={`buy-now-btn ${isAddingToCart ? "loading" : ""}`}
                    onClick={handleBuyNow}
                    disabled={isAddingToCart || productDoc?.stock <= 0}
                  >
                    {isAddingToCart
                      ? "Processing..."
                      : (checkoutBtnDoc &&
                          checkoutBtnDoc?.checkoutBtnName.btnName) ||
                        "Buy Now"}
                  </button>
                )}
              </>
              {/* ) : (
                <button
                  className="add-to-cart-btn"
                  onClick={() => handleAddToCart(document.id)}
                >
                  Add to cart
                </button>
              )} */}
            </div>
          </div>
        </div>
      </div>

      {/* PRODUCTS SETTINGS CODE START */}
      <ProductSettings />
      {/* PRODUCTS SETTINGS CODE END */}

      {/* Tabs Section */}
      {productDetailsVisibility.description &&
        productDetailsVisibility.productFeatures}

      <div className="product-detail__tabs">
        {/* Tabs Header */}
        <div className="tabs-header">
          {productDetailsVisibility.productDescription && (
            <button
              className={`tab-btn ${
                activeTab === "description" ? "active" : ""
              }`}
              onClick={() => setActiveTab("description")}
            >
              Description
            </button>
          )}
          {productDetailsVisibility.productFeatures && (
            <button
              className={`tab-btn ${activeTab === "features" ? "active" : ""}`}
              onClick={() => setActiveTab("features")}
            >
              Features
            </button>
          )}
        </div>

        {/* Tabs Content */}
        {productDetailsVisibility.productDescription &&
          activeTab === "description" && (
            <div className="tabs-content">
              <div className="tab-panel">
                <p>
                  {productDoc.description || "No description available."}&nbsp;
                  {user &&
                    (user.role === "admin" || user.role === "superAdmin") && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        width="24px"
                        viewBox="0 -960 960 960"
                        fill="currentColor"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenEditModal("description")}
                      >
                        <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z" />
                      </svg>
                    )}
                </p>
              </div>
            </div>
          )}

        {productDetailsVisibility.productFeatures &&
          activeTab === "features" && (
            <div className="tabs-content">
              <div className="tab-panel">
                <p>
                  {productDoc.features || "No features available."}
                  &nbsp;
                  {user &&
                    (user.role === "admin" || user.role === "superAdmin") && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        width="24px"
                        viewBox="0 -960 960 960"
                        fill="currentColor"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenEditModal("features")}
                      >
                        <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z" />
                      </svg>
                    )}
                </p>
              </div>
            </div>
          )}
      </div>

      {/* START PRODUCT REVIEWS */}
      <ProductReviews />
      {/* END PRODUCT REVIEWS */}
      <br />
      {/* Similar Products Section */}
      {similarProducts.length > 0 && (
        <div className="similar-products">
          <h2>More Options</h2>
          <div className="similar-products__grid">
            {similarProducts.map((product) => (
              <div
                key={product.id}
                className="similar-product-card"
                onClick={() => navigate(`/product-details-two/${product.id}`)}
              >
                <div className="similar-product-card__image">
                  <img src={product.images[0]} alt={product.name} />
                </div>
                <div className="similar-product-card__info">
                  <h3>{product.name}</h3>
                  <span className="price">
                    {currencyDoc.symbol} {product.price}
                  </span>
                  <p className="description">{product.short_description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* You may also like Section */}
      {likeableProducts.length > 0 && (
        <div className="similar-products">
          <h2>You may also like</h2>
          <div className="similar-products__grid">
            {likeableProducts.map((product) => (
              <div
                key={product.id}
                className="similar-product-card"
                onClick={() => navigate(`/product-details-two/${product.id}`)}
              >
                <div className="similar-product-card__image">
                  <img src={product.images[0]} alt={product.name} />
                </div>
                <div className="similar-product-card__info">
                  <h3>{product.name}</h3>
                  <span className="price">
                    {currencyDoc.symbol} {product.price}
                  </span>
                  <p className="description">{product.short_description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <Modal
        open={isSizeModalOpen}
        onClose={handleCloseSizeModal}
        aria-labelledby="size-modal-title"
      >
        <Box sx={modalStyle}>
          <h2 id="size-modal-title">Add New Size</h2>
          <TextField
            variant="outlined"
            type="text"
            label="Size Name"
            value={size}
            onChange={(e) => setSize(e.target.value)}
            fullWidth
            margin="normal"
          />
          {/* <TextField
            variant="outlined"
            type="text"
            label="Size URL (Optional)"
            value={sizeUrl}
            onChange={(e) => setSizeUrl(e.target.value)}
            fullWidth
            margin="normal"
            placeholder="https://example.com or /product/123"
          /> */}
          <div className="modal-actions d-flex justify-content-between">
            <Button variant="outlined" onClick={handleCloseSizeModal}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSaveSize}
              disabled={!size}
            >
              Save
            </Button>
          </div>
        </Box>
      </Modal>

      {/* MODEL FOR ADD NEW VARIENTS */}
      <Modal
        open={isVariantModalOpen}
        onClose={handleVariantModalClose}
        aria-labelledby="variant-modal-title"
        aria-describedby="variant-modal-description"
      >
        <Box sx={modalStyle}>
          <h2 id="variant-modal-title">Add New Variant</h2>
          <TextField
            variant="outlined"
            type="text"
            label="Variant Name"
            name="variantName"
            value={variantInfo.variantName}
            onChange={handleVariantChange}
            fullWidth
            margin="normal"
          />
          <TextField
            variant="outlined"
            type="number"
            label="Variant Price"
            name="variantPrice"
            value={variantInfo.variantPrice}
            onChange={handleVariantChange}
            fullWidth
            margin="normal"
          />
          <TextField
            variant="outlined"
            type="text"
            label="Variant URL"
            name="variantUrl"
            value={variantInfo.variantUrl}
            onChange={handleVariantChange}
            fullWidth
            margin="normal"
          />
          <div className="modal-actions  d-flex justify-content-between">
            <Button variant="outlined" onClick={handleVariantModalClose}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSaveVariant}>
              Save
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default ProductDetailTwo;
